var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap version_history"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_vm._m(0), _c('a', {
    staticClass: "_command[CmmComm.closeLayer]"
  }, [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(1)])])]), _c('div', {
    staticClass: "popup_content1"
  }, [_c('div', {
    staticClass: "node_order_wrap"
  }, [_c('div', {
    staticClass: "node_order_box_middle"
  }, [_c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("버전이력목록")]), _c('ul', {
    staticClass: "kind_list"
  }, _vm._l(_vm.historyList, function (history, idx) {
    return _c('li', {
      key: idx,
      class: {
        'on': _vm.selectedLogId == history.experimentLogId
      }
    }, [_c('a', {
      on: {
        "click": function ($event) {
          return _vm.selectLog(history.experimentLogId);
        }
      }
    }, [_vm._v(_vm._s(idx + 1 + ". " + history.userName) + " [" + _vm._s(history.createDate) + "]")])]);
  }), 0)]), _c('div', {
    staticClass: "node_order_box_right",
    staticStyle: {
      "flex": "3",
      "background-color": "white"
    }
  }, [_c('hot-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.cellsFromDB.length > 0,
      expression: "this.cellsFromDB.length > 0"
    }],
    key: _vm.hotKey,
    ref: "versionHandsonRef",
    attrs: {
      "settings": _vm.hotSettings,
      "licenseKey": '6c578-61cf1-e8cf5-b453c-1f850'
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.cellsFromDB.length == 0,
      expression: "this.cellsFromDB.length == 0"
    }]
  }, [_vm._m(2)])], 1)])]), _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type1",
    on: {
      "click": _vm.revertData
    }
  }, [_vm._v("버전되돌리기")]), _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v("버전이력 ")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("버전을 선택해 주세요.")])]);

}]

export { render, staticRenderFns }